<template>
  <div id="membershipbinding">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员信息管理-会员绑定</h1>
      </div>

      <div class="header-button">
        <el-button
          icon="iconfont icon-chuangjian1"
          plain
          @click="createdUser"
          >创建</el-button
        >
        <el-button icon="iconfont icon-xiugai1" plain @click="ButUpdate"
          >修改</el-button
        >
        <el-button icon="iconfont icon-a-shanchu11" @click="DeleteData" plain
          >删除</el-button
        >
        <el-button
          class="push-button"
          icon="iconfont icon-fanhui"
          plain
          @click="backHistory"
          >返回</el-button
        >
      </div>
    </div>
    <!-- 创建弹窗 -->
    <div class="create">
      <el-dialog
        width="25%"
        title="会员信息管理—会员关系绑定—关系会员创建"
        :visible.sync="createVisible"
      >
        <el-form
          size="mini"
          ref="establish"
          :label-position="labelPosition"
          label-width="5.25rem"
          :model="templatei"
          :rules="templateiRuels"
        >
          <el-form-item label="会员姓名">
            <div class="disparow">
              <el-input v-model="templatei.custName" readonly></el-input>
              <el-button
                class="selectNumber"
                @click="innerVisible = true"
                type="info"
                >选择会员</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="关系" prop="relationship">
            <el-input v-model="templatei.relationship"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ConfirmCreation">确 定</el-button>
          <el-button @click="createVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改弹窗 -->
    <div class="amend">
      <el-dialog
        width="25%"
        title="会员信息管理—会员关系绑定—关系会员修改"
        :visible.sync="amendVisible"
      >
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="11.25rem"
          :rules="formLabelAlignRuels"
          :model="formLabelAlign"
          ref="UpdateTable"
        >
          <el-form-item label="会员姓名\会员卡号\手机号">
            <el-input v-model="formLabelAlign.name" readonly></el-input>
          </el-form-item>
          <el-form-item label="关系" prop="type">
            <el-input v-model="formLabelAlign.type"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComfitUpdate">确 定</el-button>
          <el-button @click="amendVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-card shadow="never">
      <div class="flex-start">
        <div style="width: 50%">
          <el-form
            readonly
            :label-position="labelPosition"
            label-width="12.5rem"
            :model="NewsData"
            size="mini"
          >
            <el-form-item class="redItem" :inline="true" label="会员姓名">
              <el-input
                readonly
                style="width: 18.75rem"
                v-model="NewsData.userName"
              ></el-input>
            </el-form-item>
            <el-form-item label="会员等级">
              <el-input
                readonly
                style="width: 18.75rem"
                v-model="NewsData.Grade"
              ></el-input>
            </el-form-item>
            <el-form-item label="维护店">
              <el-input
                readonly
                style="width: 18.75rem"
                v-model="NewsData.maintenanceShop"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="width: 50%">
          <el-form
            :label-position="labelPosition"
            label-width="12.5rem"
            :model="NewsData"
            size="mini"
          >
            <el-form-item label="手机号">
              <el-input
                readonly
                style="width: 18.75rem"
                v-model="NewsData.Phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="会员卡号">
              <el-input
                readonly
                style="width: 18.75rem"
                v-model="NewsData.CardNumber"
              ></el-input>
            </el-form-item>
            <el-form-item label="当前维护人">
              <el-input
                readonly
                style="width: 18.75rem"
                v-model="NewsData.maintainer"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
    <div>
      <el-card shadow="never" class="card-center" style="margin-top: 0.625rem">
        <el-table
          height="500"
          class="table-style"
          border
          size="small"
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '.875rem',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="table"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @select="dialogCheck"
          v-el-table-infinite-scroll="PageTouchTheBottom"
          infinite-scroll-disabled="infiniteScrollDisabledIs"
          v-loading="PageTableLoading"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="bindCustName" label="关系会员">
          </el-table-column>
          <el-table-column prop="relation" label="关系">
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人">
          </el-table-column>
          <el-table-column prop="createTimeStr" label="创建时间">
          </el-table-column>
          <el-table-column prop="updateUserName" label="最后修改人">
          </el-table-column>
          <el-table-column
            prop="updateTimeStr"
            label="最后修改时间"
            width="250"
          >
          </el-table-column>
        </el-table>
        <el-alert
          v-if="PagesIsMore"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
        <!-- <div class="card-pagination flex-between" style="margin-top: 1.25rem">
          <span class="demonstration"
            >总计{{ paging.total }}条，每页{{ paging.size }}条</span
          >
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size='paging.size'
            @current-change="handleCurrentChange"
            :total="paging.total"
          >
          </el-pagination>
        </div> -->
      </el-card>
    </div>
    <!-- 选择会员弹窗 -->
    <div class="sales">
      <el-dialog
        width="46%"
        title="冻结卡-创建-选择会员"
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
      >
        <div style="width: 600px; margin-top: 10px">
          <el-form size="mini" label-width="180px" ref="">
            <el-form-item label="会员卡号\会员姓名\手机号">
              <div class="flex-between">
                <el-input v-model="searchFormhy.search"> </el-input>
                <el-button
                  style="
                    width: 80px;
                    margin-left: 10px;
                    background-color: #f1f1f1;
                    color: #b6b388;
                  "
                  size="small"
                  icon="el-icon-search"
                  @click="searchhy"
                  >查询</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div style="margin-top: 10px">
          <el-table
            size="small"
            class="table-style"
            height="280px"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable1"
            :data="tableData2"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="TouchTheBottom"
            infinite-scroll-disabled="onLoading"
            v-loading="loading"
          >
            <el-table-column label width="30">
              <template slot-scope="scope">
                <el-radio
                  :label="scope.$index"
                  v-model="radioxz"
                  @change.native="getCurrentRow(scope.row)"
                  >&nbsp;</el-radio
                >
              </template>
            </el-table-column>
            <el-table-column prop="custName" label="会员姓名">
            </el-table-column>
            <el-table-column prop="cardNo" width="115px" label="会员卡号">
            </el-table-column>
            <el-table-column prop="levelName" label="会员等级">
            </el-table-column>
            <el-table-column prop="regionName" label="所属区域">
            </el-table-column>
            <el-table-column prop="shopName" label="所属门店">
            </el-table-column>
            <el-table-column prop="mobile" label="移动电话"> </el-table-column>
            <el-table-column prop="state" label="状态">
              <template slot-scope="scope">
                {{ scope.row.state === 0 ? "有效" : "无效" }}
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMore"
            title="没有更多数据了!"
            type="warning"
            center
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Selectedvaluetransfer">确 定</el-button>
          <el-button @click="innerVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  bindSelectPage,
  bindInsert,
  bindupdate,
  binddelete,
  selectCustListApi,
} from "@/api/viewMemberModule";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  data() {
    return {
      PageTableLoading: false,
      amendVisible: false,
      createVisible: false,
      labelPosition: "right",
      innerVisible: false,
      disabled: false,
      loading: false,
      // 内层弹窗数据
      radioxz: "",
      tableData2: [],
      SelectChang: {},
      searchFormhy: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        total: 0,
        pageTotal:0,
      },
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pagesTotal: 0,
      },
      NewsData: {
        userName: "",
        Phone: "",
        Grade: "",
        CardNumber: "",
        maintenanceShop: "",
        maintainer: "",
      },
      formLabelAlign: {
        id: "",
        name: "",
        type: "",
      },
      formLabelAlignRuels: {
        type: [{ required: true, message: "请输入关系", trigger: "change" }],
      },
      templateiRuels: {
        relationship: [
          { required: true, message: "请输入关系", trigger: "change" },
        ],
      },
      templatei: {
        custName: "",
        relationship: "",
      }, // 获取选择会员弹窗选中的值
      tableData: [],
    };
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
      MemberInformation: (state) => state.user.MemberInformation,
    }),
    PagesIsMore() {
      return this.paging.page >= this.paging.pagesTotal;
    },
    infiniteScrollDisabledIs() {
      return this.PageTableLoading || this.PagesIsMore;
    },
    isMore() {
      return this.searchFormhy.pageNo >= this.searchFormhy.pageTotal;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  created() {
    this.NewsData.userName =
      this.MemberInformation.lastName + this.MemberInformation.firstName;
    this.NewsData.Phone = this.MemberInformation.mobile;
    this.NewsData.Grade = this.MemberInformation.levelNameCn;
    this.NewsData.CardNumber = this.MemberInformation.cardNo;
    this.NewsData.maintenanceShop = this.MemberInformation.serviceOrgCode;
    this.NewsData.maintainer = this.MemberInformation.serviceEmpCode;
    this.RbindSelectPage();
    this.RselectCustListApi();
  },
  methods: {
    createdUser(){
       this.createVisible = true 
    },
    PageTouchTheBottom() {
      this.PageTableLoading = true;
      setTimeout(() => {
        this.paging.page += 1;
        this.RbindSelectPage();
      }, 200);
    },
    ConfirmCreation() {
      this.$refs.establish.validate((valid) => {
        if (valid) {
          let data = require("qs").stringify({
            cpyNo: getcpyNo,
            custID: this.custID,
            bindCustID: this.templatei.custID,
            relation: this.templatei.relationship,
          });
          bindInsert(data).then((res) => {
            if (res.success) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.createVisible = false;
              this.tableData=[]
              this.paging.page=1
              this.RbindSelectPage();
              this.templatei={}
            } else {
              this.$message({
                message: "添加失败,请重试",
                type: "warning",
              });
            }
          });
        }
      });
    },
    // 选择会员
    Selectedvaluetransfer() {
      this.innerVisible = false;
    },
    getCurrentRow(row) {
      this.templatei = row;
    },
    TouchTheBottom() {
      this.loading = true;
      setTimeout(() => {
        this.searchFormhy.pageNo += 1;
        this.RselectCustListApi();
      }, 100);
      // if (
      //   this.searchFormhy.pageNo >=
      //   this.searchFormhy.total / this.searchFormhy.pageSize
      // ) {
      //   this.loading = false;
      //   this.isMore = true;
      // } else {
      //   this.loading = true;
      //   this.searchFormhy.pageNo++;
      //   this.RselectCustListApi();
      // }
    },
    searchhy() {
      this.searchFormhy.pageNo == 1;
      let data = require("qs").stringify(this.searchFormhy);
      selectCustListApi(data).then((res) => {
        this.tableData2 = res.data.list;
        this.searchFormhy.total = res.data.total;
        this.loading = false;
      });
    },
    // 选择会员列表
    RselectCustListApi() {
      let data = require("qs").stringify(this.searchFormhy);
      selectCustListApi(data).then((res) => {
        this.tableData2 = this.tableData2.concat(res.data.list);
        this.searchFormhy.total = res.data.total;
        this.searchFormhy.pageTotal=res.data.pages
        this.loading = false;
      });
    },
    RbindSelectPage() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        pageNo: this.paging.page,
        pageSize: this.paging.size,
        custID: this.custID,
      });
      bindSelectPage(data).then((res) => {
        if (res.success) {
          this.tableData = this.tableData.concat(res.data.list);
          this.paging.total = res.data.total;
          this.paging.pagesTotal = res.data.pages;
          this.PageTableLoading = false;
        }
      });
    },
    ButDelete() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        ID: this.SelectChang.id,
      });
      binddelete(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.$refs.table.clearSelection();
          this.paging.page = 1;
          this.tableData = [];
          this.RbindSelectPage();
        } else {
          this.$message({
            message: "删除失败,请重试",
            type: "warning",
          });
        }
      });
    },
    handleCurrentChange(event) {
      this.paging.page = event;
      this.RbindSelectPage();
    },
    ButUpdate() {
      if (Object.keys(this.SelectChang).length < 1) {
        this.$message.info("请选择数据,进行修改!");
        return false;
      } else {
        this.formLabelAlign.name =
          this.MemberInformation.lastName + this.MemberInformation.firstName;
        this.formLabelAlign.id = this.SelectChang.id;
        this.formLabelAlign.type = this.SelectChang.relation;
        this.amendVisible = true;
      }
    },
    ComfitUpdate() {
      this.$refs.UpdateTable.validate((valid) => {
        if (valid) {
          let data = require("qs").stringify({
            cpyNo: getcpyNo,
            custID: this.custID,
            relation: this.formLabelAlign.type,
            ID: this.formLabelAlign.id,
          });
          bindupdate(data).then((res) => {
            if (res.success) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.$refs.table.clearSelection();
              this.amendVisible = false;
              this.paging.page = 1;
              this.tableData = [];
              this.RbindSelectPage();
            } else {
              this.$message({
                message: "修改失败,请重试",
                type: "warning",
              });
            }
          });
        }
      });
    },
    DeleteData() {
      if (Object.keys(this.SelectChang).length < 1) {
        this.$message.info("请选择数据");
        return false;
      } else {
        this.$confirm('此操作将永久删除该条记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.ButDelete()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      }
    },
    dialogCheck(selection, row) {
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectioned = row;
        this.$refs.table.toggleRowSelection(row, true);
      }
    },
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.SelectChang = e[e.length - 1];
      } else {
        this.SelectChang = {};
      }
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 点击返回按钮  返回上一页面
    backHistory() {
      this.$router.go(-1); //返回上一层
    },
  },
};
</script>
<style lang="scss" scoped>
.disparow {
  display: flex;
  flex-direction: row;
  align-content: center;
  .selectNumber {
    margin-left: 10px;
    color: #ffffff;
  }
}
#membershipbinding {
  // height: 81.25rem;
  height: 100%;
}
.header {
  color: aliceblue;

  .header-text {
    height: 3.125rem;
    margin-top: 1.25rem;
    color: #76734f;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border: none;
  color: #a19b59;
}
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.readonly).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }

  //创建弹框样式
  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 0.875rem;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 3.75rem;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
  //创建弹框样式
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 0.875rem;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 3.75rem;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
}
</style>
